function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 2,
  rx: 1
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 8,
  width: 24,
  height: 2,
  rx: 1
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  y: 16,
  width: 24,
  height: 2,
  rx: 1
});

function SvgDerburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    fill: "#333"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIxOCIgZmlsbD0iIzMzMyIgeG1sbnM6dj0iaHR0cHM6Ly92ZWN0YS5pby9uYW5vIj48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMiIgcng9IjEiLz48cmVjdCB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMiIgcng9IjEiLz48cmVjdCB5PSIxNiIgd2lkdGg9IjI0IiBoZWlnaHQ9IjIiIHJ4PSIxIi8+PC9zdmc+";
export { SvgDerburger as ReactComponent };